import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Flex,
  Image,
  message,
  Row,
  Space,
  Spin,
  Grid,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import publicDataServices from "../../../APIs/publicDataServices";

import CategoryBanner from "../../../Images/Common/category-banner.png";

import { settings } from "../../../Services/apiSetting";
import { getProductsUrl } from "../../../Components/Common/helpers";

import "../../App/App.css";

const { useBreakpoint } = Grid;

const Categories = () => {
  const screens = useBreakpoint();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const response = await publicDataServices.getCategories();

      if (response?.status === 200) {
        setCategories(JSON.parse(response.data.data));

        setIsLoading(false);
      } else {
        messageApi.error("Failed to fetch categories.");

        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);

      messageApi.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to fetch categories. Please try again."
      );

      setIsLoading(false);
    }
  };

  const getCardWidth = () => {
    if (screens.xs) return "100%"; // phones
    if (screens.sm) return "50%"; // tablets
    if (screens.md) return "33.33%"; // small desktops

    return "25%"; // large desktops
  };

  return (
    <Space
      direction="vertical"
      className="page-container"
      style={{
        paddingBottom: 0,
        marginBottom: 0,
      }}
    >
      {contextHolder}

      {isLoading ? (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      ) : (
        <>
          <Space
            direction={screens.md ? "horizontal" : "vertical"}
            size={30}
            style={{ width: "100%", justifyContent: "space-around" }}
          >
            <Flex vertical style={{ textAlign: "left" }}>
              <h2
                style={{
                  color: "#002753",
                  fontSize: screens.md ? 30 : 36,
                  fontWeight: "bold",
                  marginBottom: 15,
                }}
              >
                Browse by Category
              </h2>

              <p
                style={{
                  color: "#4B5563",
                  fontSize: 16,
                }}
              >
                Find the right product type for your project needs.
              </p>
            </Flex>

            <Image
              preview={false}
              src={CategoryBanner}
              alt="Category Banner"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                marginTop: screens.md ? 50 : 0,
              }}
            />
          </Space>

          <Row
            gutter={[16, 16]}
            style={{
              marginTop: 50,
              marginBottom: 50,
              // paddingLeft: screens.xs ? 0 : "5vw",
              // paddingRight: screens.xs ? 0 : "5vw",
            }}
          >
            {categories.map((item, index) => (
              <Col
                key={index}
                xs={24} // 1 per row on mobile (<576px)
                sm={12} // 2 per row on tablet (≥576px)
                md={8} // 3 per row on medium screens (≥768px)
                lg={6} // 4 per row on large screens (≥992px)
                xl={6}
              >
                <Link
                  to={getProductsUrl({
                    selectedKey: `cat-${item.Id}`,
                    categoryName: item.CategoryName,
                  })}
                  style={{ display: "block", height: "100%", color: "inherit" }}
                >
                <Card
                  key={index}
                  hoverable
                  cover={
                    <Image
                      preview={false}
                      alt={item.CategoryName}
                      src={settings.categoryImageFolder + item.ImageTag}
                      height={220}
                      width="100%"
                      style={{ padding: 16 }}
                      fallback="data:image/png;base64,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"
                    />
                  }
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                  styles={{
                    body: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      paddingTop: 0,
                      height: "auto", // let it grow based on text length
                    },
                  }}
                >
                  <h3
                    style={{
                      color: "#003366",
                      fontWeight: 600,
                      marginTop: 0,
                      marginBottom: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2, // clamp to 2 lines max
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {item.CategoryName}
                  </h3>

                  <p
                    style={{
                      color: "#4B5563",
                      fontSize: 14,
                      marginBottom: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {item.Description}
                  </p>
                </Card>
                </Link>
              </Col>
            ))}
          </Row>

          <Space
            justify="center"
            direction="vertical"
            className="no-margin-box"
            style={{ backgroundColor: "#F9FAFB" }}
          >
            <p
              style={{
                color: "#002753",
                fontSize: screens.md ? 24 : 28,
                fontWeight: "bold",
                textAlign: "center",
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              Need help deciding?
            </p>

            <Flex
              gap={8}
              wrap="wrap"
              justify="center"
              align="center"
              direction="column"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                marginBottom: 30,
              }}
            >
              <Button
                type="primary"
                style={{
                  backgroundColor: "#002753",
                  borderColor: "#002753",
                  color: "white",
                  padding: 20,
                  width: 180,
                }}
                href="/products"
              >
                View All Products
              </Button>

              <Button
                type="primary"
                style={{
                  backgroundColor: "#002753",
                  borderColor: "#002753",
                  color: "white",
                  padding: 20,
                  width: 180,
                }}
                onClick={() => navigate("/contact-us")}
              >
                Contact Us
              </Button>
            </Flex>
          </Space>
        </>
      )}
    </Space>
  );
};

export default Categories;
